export const MOBILE_PAYMENT_CHARGING_REQUEST_START = 'MOBILE_PAYMENT_CHARGING_REQUEST_START';
export const MOBILE_PAYMENT_CHARGING_REQUEST_SUCCESS = 'MOBILE_PAYMENT_CHARGING_REQUEST_SUCCESS';
export const MOBILE_PAYMENT_CHARGING_REQUEST_FAIL = 'MOBILE_PAYMENT_CHARGING_REQUEST_FAIL';

export const MOBILE_PAYMENT_SMS_CONFIRMATION_CHECK_START = 'MOBILE_PAYMENT_SMS_CONFIRMATION_CHECK_START';
export const MOBILE_PAYMENT_SMS_CONFIRMATION_CHECK_SUCCESS = 'MOBILE_PAYMENT_SMS_CONFIRMATION_CHECK_SUCCESS';
export const MOBILE_PAYMENT_SMS_CONFIRMATION_CHECK_FAIL = 'MOBILE_PAYMENT_SMS_CONFIRMATION_CHECK_FAIL';

export const MOBILE_PAYMENT_CREDIT_CARD_REDIRECT = 'MOBILE_PAYMENT_CREDIT_CARD_REDIRECT';
